<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage" @change="getSummaryType">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="姓名" v-if="summaryType == 2">
                            <c-input name="user_realname"  placeholder="请输入姓名，模糊匹配"></c-input>
                        </m-search-item>
                        <m-search-item label="分类">
                            <c-select  name="category_id" v-model="categoryId" async @search="searchCategory"></c-select>
                        </m-search-item>
                        <m-search-item label="品牌">
                            <c-select name="brand_id" v-model="brandId" async @search="searchBrand"></c-select>
                        </m-search-item>
                        <m-search-item label="产品型号">
                            <c-input name="model_name" placeholder="请输入型号名称，模糊匹配"></c-input>
                        </m-search-item>
                        <m-search-item label="颜色" v-if="summaryType == 1">
                            <c-input  name="color_name" placeholder="请输入颜色名称，模糊匹配"></c-input>
                        </m-search-item>
                        <m-search-item label="等级" v-if="summaryType == 1">
                            <c-select  name="level_type" async @search="searchDicInfo('LEVEL_TYPE', arguments[0], arguments[1])"></c-select>
                        </m-search-item>
                    </m-search>
                </template>
                <template #operate>
                    <c-button v-if="auth('b_storage_distribution_export')" prepend-icon="tf-export"
                              @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <template #produce_info="{data}">
                    <p class="product-name">
                        <c-state v-if="data.level_type" tag dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                        <span>{{data.produce_info || getProductText(data)}}</span>
                    </p>
                </template>
                <!--等级-->
                <template #level_type="{data}">
                    <c-state tag async dict="LEVEL_TYPE" :value="data.level_type"></c-state>
                </template>
                <!--采购总价-->
                <template #purchase_money="{data}">
                    ￥{{data.purchase_money}}
                </template>
                <!--维修总价-->
                <template #repair_money="{data}">
                    ￥{{data.repair_money}}
                </template>
                <!--总成本-->
                <template #cost_money="{data}">
                    ￥{{data.cost_money}}
                </template>
                <!--平均时长-->
                <template #avg_occupy_duration="{data}">
                    {{data.avg_occupy_duration}}天
                </template>
            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'
import MProductInfo from "../../components/module/product_info.vue";

export default {
    name: 'm_storage_distribution',
    components: {MProductInfo},

    computed: {
        ...mapState(['saasInfo','userInfo'])
    },

    data() {
        return {
            workType: 25,            //库存分布列表
            categoryId: 0,          //已选中的分类ID
            brandId: 0,             //已选中的品牌ID
            summaryType:1           //【统计方式】1=按照机型  2=按照人员
        }
    },
    methods: {

        /*********获取产品信息文字**********/
        getProductText(data) {
            var parts = [];
            if (data.brand_name) parts.push(data.brand_name);
            if (data.spu_model_name) parts.push(data.spu_model_name);
            if (data.memory_name) parts.push(data.memory_name);
            if (data.color_name) parts.push(data.color_name);
            return parts.join(' ') || '-';
        },
        /*******搜索分类*****************/
        getSummaryType(viewId) {
            this.request({
                url: '/sys_user_view/summary_type/filte',
                data: {
                    view_id: viewId
                },
                success: data => {
                    this.summaryType = data||1;
                }
            })
        },
        /*******搜索分类*****************/
        searchCategory(keyword, resolve) {
            this.request({
                url: '/spu/category/options',
                data: {
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },

        /*******搜索品牌*****************/
        searchBrand(keyword, resolve) {
            this.request({
                url: '/spu/brand/options',
                data: {
                    category_id: this.categoryId,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        },
        /*******搜索参数信息****************/
        searchDicInfo(dic_type_code, keyword, resolve) {
            this.request({
                url: '/dic/info/options',
                data: {
                    dic_type_code: dic_type_code,
                    keyword: keyword
                },
                success: data => {
                    resolve(data);
                }
            })
        }
    }
}
</script>